import Table from "src/components/Common/UI/DndTable/Table";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import React from "react";
import { MisterIcon } from "@rtel/mister-icons";
import { Button } from "reactstrap";
import Modal from "src/components/Common/UI/Modal/Modal";
import CreateAtmServiceProvider from "./CreateAtmServiceProvider";
import { useAtmServiceProvidersDataViewLogic } from "./hooks/useAtmServiceProvidersDataViewLogic";
import EditAtmServiceProvider from "./EditAtmServiceProvider";
import DeleteAtmServiceProvider from "./DeleteAtmServiceProvider";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";


const AtmServiceProvidersDataView = () => {

  const {
    data,
    columns,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    t,
    modalEvent
  } = useAtmServiceProvidersDataViewLogic();

  const addAreaButton: React.FC = () => {
    return (
      <Button
        type="button"
        color="dark"
        onClick={ () => { actionEvent({action: "create"}); }}
        className="mb-1"
        size="sm"
        data-toggle="modal"
      >
        <MisterIcon name="Plus" size="sm" className="icon-light" /> {t(`Νέo ATM Service Provider`)}
      </Button>
    )
  };

  const ActionButtons: React.FC = () => (
    <TableActionButtons event={actionEvent} canEdit={selectedRowsOfTable.length > 0} canDelete={false} />
  );

  return (
    <>
        {loadingDone && (
          <>
            <Table
                columns={columns}
                data={data}
                defaultOrderByKeyFilter={"id"}
                showNumberOfRows={false}
                rowSelection={true}
                setRowSelection={setSelectedRowsOfTable}
                multipleRowSelection={false}
                actionRowId={"id"}
                debugMode={false}
                noDataFoundTitle="No AtmServiceProviders yet"
                isChangeOrderOrVisibilityEnable={false}
                ButtonsAreaLeft={ActionButtons}
                ButtonsAreaRight={addAreaButton}
                textPosition="center"
            />
          </>
        )}

        <Modal
          isOpen={!!modalEvent.action}
          closeFilterModal={closeActionModal}
          title={getModalTitleByAction()}  
          >
            {modalEvent.action === "create" && <CreateAtmServiceProvider handleCloseModal={closeActionModal}/> }
            {modalEvent.action === "edit" && <EditAtmServiceProvider handleCloseModal={closeActionModal} atmServiceProviderId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
            {modalEvent.action === "delete" && <DeleteAtmServiceProvider handleCloseModal={closeActionModal} atmServiceProviderId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
        </Modal>

        {!loadingDone && <LoadingSpinner />}
    </>
  )
}

export default AtmServiceProvidersDataView;

